import { Collapse, Image, Spin } from 'antd';
import { useTranslation } from 'translations/hooks';

import styles from './index.module.scss';

export interface Picture {
  path: string;
  description: string;
}

const PicturesCollapse = ({ pictures }: { pictures: Picture[] }) => {
  const { t } = useTranslation();

  return (
    <Collapse
      ghost
      className={styles.customCollapse}
      items={[
        {
          key: '1',
          label: t('qualityControl.segmentHistory.drawer.details.pictures'),
          children: (
            <>
              {pictures.map((picture, index) => (
                <Image
                  key={index}
                  alt={picture.description}
                  src={picture.path}
                />
              ))}
            </>
          ),
        },
      ]}
    />
  );
};

export const PicturesList = ({
  pictures,
  isLoading,
}: {
  pictures: Picture[];
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <Spin />;
  }

  return pictures.length ? <PicturesCollapse pictures={pictures} /> : null;
};
